import { jsx as _jsx } from "react/jsx-runtime";
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/index';
import { TS_Icons } from '@nu-art/ts-styles';
export const Input_Text_Blur = TS_InputV2.editable({ saveEvent: ['blur'], type: 'text' });
export const Input_Number_Blur = TS_InputV2.editable({ saveEvent: ['blur'], type: 'number' });
export const DropDownCaret = {
    open: _jsx(TS_Icons.treeCollapse.component, {}),
    close: _jsx(TS_Icons.treeCollapse.component, { className: 'flip' })
};
//# sourceMappingURL=components.js.map